import { createSelector } from "@reduxjs/toolkit";

export const DeviceSelector = createSelector(
    (state: any) => state.device,
    (device) => device
)